import statistics from '@/quran/statistics.json'

export function calculateTotals(
  fromSura: number,
  fromAyah: number,
  toSura: number,
  toAyah: number
): { totalLines: number; totalPages: number } {
  let totalLines = 0
  let totalPages = 0

  for (const verse of statistics) {
    const sura = verse.surah_number
    const ayah = verse.verse_number
    
    if (
      (sura > fromSura || (sura === fromSura && ayah >= fromAyah)) &&
      (sura < toSura || (sura === toSura && ayah <= toAyah))
    ) {
      totalLines += verse.line_quantity
      totalPages += verse.page_quantity
    }
  }

  return {
    totalLines,
    totalPages
  }
}
